
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

interface BecomeCoachFormProps {
  onSubmit: (data: any) => Promise<void>;
  loading?: boolean;
}

export const BecomeCoachForm = ({ onSubmit, loading }: BecomeCoachFormProps) => {
  const { t } = useTranslation('supervision');
  const [formData, setFormData] = useState({
    coach_name: "",
    certification: "",
    specialization: "",
    contact_email: ""
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(formData);
  };

  const handleChange = (field: string, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Card className="max-w-md mx-auto">
      <CardHeader>
        <CardTitle>{t('dashboard.becomeCoach.form.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="coach_name">{t('dashboard.becomeCoach.form.coachName')}</Label>
            <Input
              id="coach_name"
              value={formData.coach_name}
              onChange={(e) => handleChange("coach_name", e.target.value)}
              required
            />
          </div>

          <div>
            <Label htmlFor="contact_email">{t('dashboard.becomeCoach.form.contactEmail')}</Label>
            <Input
              id="contact_email"
              type="email"
              value={formData.contact_email}
              onChange={(e) => handleChange("contact_email", e.target.value)}
              required
            />
          </div>

          <div>
            <Label htmlFor="certification">{t('dashboard.becomeCoach.form.certification')}</Label>
            <Input
              id="certification"
              value={formData.certification}
              onChange={(e) => handleChange("certification", e.target.value)}
              placeholder={t('dashboard.becomeCoach.form.certificationPlaceholder')}
            />
          </div>

          <div>
            <Label htmlFor="specialization">{t('dashboard.becomeCoach.form.specialization')}</Label>
            <Textarea
              id="specialization"
              value={formData.specialization}
              onChange={(e) => handleChange("specialization", e.target.value)}
              placeholder={t('dashboard.becomeCoach.form.specializationPlaceholder')}
              rows={3}
            />
          </div>

          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? t('dashboard.becomeCoach.form.submitting') : t('dashboard.becomeCoach.form.submitButton')}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};
